<template>
  <div>
    <div class="sig-tags-list">
      <div class="sig-tag-card" v-for="(tag, key) in significantTags" :key="key">
        <UserAddedTag :tag="tag" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import UserAddedTag from "./UserAddedTag.vue";

const store = useStore();
let significantTags = computed(() => {
  return store.state.Persistence.significantTags ?? [];
});
store.dispatch('getSignificantTags');
</script>

<style scoped>


.sig-tags-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}

.sig-tags-title {
  font-size: 2rem;
  font-weight: 700;
  color: #222;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  text-align: center;
}

.sig-tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin-top: 1.5rem;
}

.sig-tag-card {
  position: relative;
  font-size: 1rem;
  margin: 0;
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;
}
</style>
